import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { format } from 'date-fns';

interface CalendarHeaderProps {
  currentMonth: Date;
  onPreviousMonth: () => void;
  onNextMonth: () => void;
  onGoToToday: () => void;
}

const CalendarHeader: React.FC<CalendarHeaderProps> = ({
  currentMonth,
  onPreviousMonth,
  onNextMonth,
  onGoToToday
}) => {
  return (
    <div className='flex items-center justify-between p-4 border-b border-gray-200'>
      <h2 className='text-xl font-semibold text-gray-900'>
        {format(currentMonth, 'MMMM yyyy')}
      </h2>
      <div className='flex items-center space-x-2'>
        <button
          onClick={onGoToToday}
          className='px-3 py-1 text-sm font-medium text-blue-600 hover:text-blue-700 hover:bg-blue-50 rounded-md transition-colors'
        >
          Today
        </button>
        <button
          onClick={onPreviousMonth}
          className='p-1 text-gray-500 hover:text-slate-700 hover:bg-gray-100 rounded-md transition-colors'
          aria-label='Previous month'
        >
          <ChevronLeft className='w-5 h-5' />
        </button>
        <button
          onClick={onNextMonth}
          className='p-1 text-gray-500 hover:text-slate-700 hover:bg-gray-100 rounded-md transition-colors'
          aria-label='Next month'
        >
          <ChevronRight className='w-5 h-5' />
        </button>
      </div>
    </div>
  );
};

export default CalendarHeader;
